/**
 * PerformAI API
 * PerformAI API documentation
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RoleDTO {
    activationZone: boolean;
    allActivationZone: boolean;
    allSports: boolean;
    cloud: boolean;
    dashboard: boolean;
    description: string;
    discount?: number;
    excelReport: boolean;
    fullDashboard: boolean;
    id?: string;
    image: string;
    name: string;
    numberOfAiAnalyses: number;
    numberOfPlayers: number;
    numberOfReports: number;
    panel: boolean;
    pdfReport: boolean;
    price: number;
    promoteVideoToAction: boolean;
    roleManagement: boolean;
    saleable?: boolean;
    saveOnly: boolean;
    status: string;
    templateEditor: boolean;
    templateViewer: boolean;
    uploadCount: number;
    userManagement: boolean;
    wordReport: boolean;
}

